if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        console.log("[product-form] constructor");

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        console.log("[product-form] init", {
          hasCart: !!this.cart,
          hideErrors: this.hideErrors,
          submitBtnExists: !!this.submitButton,
          submitBtnAriaDisabled: this.submitButton?.getAttribute('aria-disabled'),
          submitBtnDisabledAttr: this.submitButton?.getAttribute('disabled'),
          initialVariantId: this.variantIdInput?.value
        });
      }

      onSubmitHandler(evt) {
        console.group("[product-form] onSubmit");
        evt.preventDefault();

        const ariaDisabled = this.submitButton.getAttribute('aria-disabled');
        console.log("aria-disabled before submit:", ariaDisabled);

        if (ariaDisabled === 'true') {
          console.warn("[product-form] submit blocked: aria-disabled=true");
          console.groupEnd();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const currentVariantId = formData.get('id');
        console.log("submitting variant id:", currentVariantId);

        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sections);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
          console.log("cart present → sections + sections_url appended", { sections });
        } else {
          console.log("no cart component found → will redirect to cart on success");
        }

        config.body = formData;

        console.time("[product-form] fetch cart_add");
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            console.timeEnd("[product-form] fetch cart_add");
            console.log("cart_add raw response.ok/status:", response.ok, response.status);
            return response.json();
          })
          .then((response) => {
            console.log("cart_add parsed response:", response);

            // Shopify returns {status, message, description, errors} on failure
            if (response.status) {
              console.warn("[product-form] add-to-cart server signaled error", {
                variantId: currentVariantId,
                errors: response.errors || response.description,
                message: response.message
              });

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: currentVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) {
                console.log("no .sold-out-message element; leaving UI as-is");
                return;
              }

              // This is where users often see the “Sold out” state get stuck:
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              console.log("[product-form] set sold-out UI", {
                ariaDisabled: this.submitButton.getAttribute('aria-disabled'),
                hasSoldOutMessage: true
              });
              return;
            } else if (!this.cart) {
              console.log("success & no cart UI → redirect to cart");
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              console.log("publishing cartUpdate", { variantId: currentVariantId });
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: currentVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                console.log("cartUpdate subscribers done");
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              console.log("in quick-add-modal → deferring cart.renderContents until modalClosed");
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                      console.log("cart contents rendered (post modal close)");
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                console.log("cart contents rendered");
              });
            }
          })
          .catch((e) => {
            console.error("[product-form] fetch error", e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

            if (!this.error) {
              this.submitButton.removeAttribute('aria-disabled');
              console.log("final → enable submit (no error)");
            } else {
              console.log("final → keep disabled due to error", {
                ariaDisabled: this.submitButton.getAttribute('aria-disabled')
              });
            }

            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent("add:user-action", evt);

            console.groupEnd();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          console.log("[product-form] handleErrorMessage: hidden");
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) {
          console.log("[product-form] handleErrorMessage: wrapper not found");
          return;
        }

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
j
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          console.warn("[product-form] error message shown:", errorMessage);
        } else {
          console.log("[product-form] error message hidden");
        }
      }

      toggleSubmitButton(disable = true, text) {
        // This method is often called by variant selection components.
        console.log("[product-form] toggleSubmitButton", { disable, text });

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
          console.log("[product-form] submitButton → disabled", {
            ariaDisabled: this.submitButton.getAttribute('aria-disabled'),
            disabledAttr: this.submitButton.getAttribute('disabled')
          });
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          console.log("[product-form] submitButton → enabled", {
            ariaDisabled: this.submitButton.getAttribute('aria-disabled'),
            disabledAttr: this.submitButton.getAttribute('disabled')
          });
        }
      }

      get variantIdInput() {
        const el = this.form.querySelector('[name=id]');
        // Handy to confirm the variant input exists and is enabled:
        if (!el) {
          console.warn("[product-form] [name=id] input not found");
        } else {
          // Do this sparingly to avoid noisy logs while typing:
          // console.log("[product-form] variantIdInput accessed:", { value: el.value, disabled: el.disabled });
        }
        return el;
      }
    }
  );
}
